<template>
    <div class="machine-config-error">
        <div class="machine-config-error-content">
            <img :src="errorIcon" alt="">
            <h1>{{ errorTitle }}</h1>
            <h2>{{ errorMessage }}</h2>
            <div v-if="scannedCode" class="machine-code">
                <span>{{ $t("m.scannedMachine") }}</span>
                <strong>{{ scannedCode }}</strong>
            </div>
            <button v-if="map_enabled" v-active-touch class="primary-btn nearby-btn" type="button" @click="goNearbyRentMap">
                {{ $t("m.loginViewNearbyRentableMachines") }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import serverErrorIcon from "@/assets/error_icons/server-error.webp";
import stationOfflineIcon from "@/assets/error_icons/station-offline.webp";
import stationNotSetUpIcon from "@/assets/error_icons/station-not-set-up.webp";
import powerBanksUnavailableIcon from "@/assets/error_icons/power-banks-unavailable.webp";
import noPowerBanksAvailableIcon from "@/assets/error_icons/no-power-banks-available.webp";
import { getMapRouteOrFallback } from "@/utils/mapFeature";

export default {
    name: "MachineConfigError",
    data() {
        return {
            errorTitle: '',
            errorMessage: '',
        };
    },
    computed: {
        ...mapGetters('appConfig', ['device_code', 'machine_precheck_error', 'map_enabled']),
        errorCode() {
            return Number(this.$route.query.errorCode) ||
                Number(this.machine_precheck_error && this.machine_precheck_error.code) ||
                0;
        },
        scannedCode() {
            return this.$route.query.code ||
                (this.machine_precheck_error && this.machine_precheck_error.device_code) ||
                this.device_code ||
                '';
        },
        errorIcon() {
            switch (this.errorCode) {
                case 50101:
                case 50102:
                case 50107:
                    return stationNotSetUpIcon;
                case 50106:
                    return stationOfflineIcon;
                case 50108:
                    return powerBanksUnavailableIcon;
                case 50110:
                    return noPowerBanksAvailableIcon;
                default:
                    return serverErrorIcon;
            }
        },
        mapRoute() {
            return getMapRouteOrFallback({
                mapEnabled: this.map_enabled,
                isBorrow: this.$store.getters.is_borrow,
                deviceCode: this.device_code,
                machinePrecheckError: this.machine_precheck_error,
            });
        },
    },
    created() {
        this.setErrorContent();
    },
    methods: {
        setErrorContent() {
            switch (this.errorCode) {
                case 50101:
                    this.errorTitle = this.$t('m.stationNotFoundTitle');
                    this.errorMessage = this.$t('m.stationNotFound');
                    break;
                case 50102:
                    this.errorTitle = this.$t('m.stationNotSetUpTitle');
                    this.errorMessage = this.$t('m.stationNotSetUp');
                    break;
                case 50106:
                    this.errorTitle = this.$t('m.stationOfflineTitle');
                    this.errorMessage = this.$t('m.stationOffline');
                    break;
                case 50107:
                    this.errorTitle = this.$t('m.stationBusyTitle');
                    this.errorMessage = this.$t('m.stationBusy');
                    break;
                case 50108:
                    this.errorTitle = this.$t('m.powerBanksUnavailableTitle');
                    this.errorMessage = this.$t('m.powerBanksUnavailable');
                    break;
                case 50110:
                    this.errorTitle = this.$t('m.noPowerBanksAvailableTitle');
                    this.errorMessage = this.$t('m.noPowerBanksAvailable');
                    break;
                default:
                    this.errorTitle = this.$t('m.serverErrorTitle');
                    this.errorMessage = this.$route.query.message || this.$t('m.serverError');
            }
        },
        goNearbyRentMap() {
            this.$router.push(this.mapRoute);
        },
    },
};
</script>

<style lang="scss">
    .machine-config-error {
        background: #fff;
        position: absolute;
        inset: 0;
    }

    .machine-config-error-content {
        position: absolute;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
            height: 35px;
            width: auto;
            max-width: 40px;
        }

        h1 {
            margin: 0;
            color: #202124;
            font-family: "SF Pro Display";
            font-size: 20px;
            font-weight: 700;
            line-height: 140%;
            margin-top: 10px;
            margin-bottom: 5px;
            text-align: center;
        }

        h2 {
            margin: 0;
            width: 283px;
            font-size: 14px;
            font-weight: 400;
            line-height: 20.16px;
            color: #333333;
            text-align: center;
        }

        .machine-code {
            width: 283px;
            margin-top: 18px;
            padding: 11px 13px;
            border-radius: 5px;
            background: #f7f7f7;
            color: #555;
            font-size: 12px;
            line-height: 16px;
            box-sizing: border-box;

            span,
            strong {
                display: block;
            }

            strong {
                margin-top: 3px;
                color: #202124;
                font-size: 15px;
                font-weight: 600;
                word-break: break-all;
            }
        }

        .nearby-btn {
            width: 283px;
            margin-top: 20px;
            background: #FFFFFF;
            color: #333;
        }
    }
</style>
